import type { SearchCriteria, PartialSearchCriteria } from '../../model/types';

interface BlockParams {
  block?: true;
}

export function block(criteria: SearchCriteria | PartialSearchCriteria): BlockParams {
  if (criteria.block) {
    return { block: true };
  }
  return {};
}
